import { Component, Inject, PLATFORM_ID } from '@angular/core';
import {
   FormControl,
   FormGroup,
   FormsModule,
   ReactiveFormsModule,
   UntypedFormBuilder,
   UntypedFormGroup,
   Validators
} from '@angular/forms';
import { TrabalheConosco } from '../model/integracao';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { TrabalheConoscoService } from '../services/trabalhe-conosco.service';
import { ValidatorsService } from '../utils/utils.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { TitleComponent } from '../components/title/title.component';
import { LojasComponent } from '../components/lojas/lojas.component';
import { ContatoService } from '../services/contato.service';
import { buildWhatsAppUrl } from '../imoveis/detalhes-imovel/detalhes-imovel.util';

@Component({
   selector: 'app-contato',
   standalone: true,
   imports: [ReactiveFormsModule, CommonModule, FormsModule, NgxMaskDirective, TitleComponent, LojasComponent],
   templateUrl: './contato.component.html',
   styleUrl: './contato.component.scss',
   providers: [provideNgxMask()]
})
export class ContatoComponent {
   isLoading: boolean = false;
   submitted: boolean = false;
   validate!: string;

   form!: FormGroup<{
      nome: FormControl<string>;
      telefone: FormControl<string>;
      email: FormControl<string>;
      texto: FormControl<string>;
   }>;

   constructor(
      private fb: UntypedFormBuilder,
      public validator: ValidatorsService,
      private toastr: ToastrService,
      @Inject(PLATFORM_ID) private platformId: Object,
      private router: Router,
      private contatoService: ContatoService
   ) { }

   ngOnInit(): void {
      this.initForm();

      if (isPlatformBrowser(this.platformId)) {
         this.checkMobile();
         if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkMobile.bind(this));
         }

         // 🔹 Garante que o scroll acontece depois da renderização
         setTimeout(() => {
            window.scrollTo(0, 0);
         });

         // 🔹 Faz o scroll ao navegar entre páginas
         this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
               setTimeout(() => {
                  window.scrollTo(0, 0);
               });
            }
         });
      }
   }

   mobile: boolean = false;
   checkMobile() {
      if (typeof window !== 'undefined') {
         this.mobile = window.innerWidth < 935;
      }
   }

   async enviar() {
      this.submitted = true;

      let email = this.form.get('email')?.value;
      const caracter = email.includes('@');
      if (!caracter) {
         this.toastr.warning('Email inválido.', 'Ops!');
      }

      if (this.form.valid) {
         try {
            this.isLoading = true;
            const params = this.form.value;
            await this.contatoService.enviarEmail({
               nome: params.nome,
               email: params.email,
               telefone: params.telefone,
               mensagem: params.texto
            });
            this.toastr.success('Enviado com sucesso', 'Sucesso');
         } catch (e) {
            this.toastr.error('Um erro ocorreu, tente novamente mais tarde', 'Erro');
            console.error(e);
         } finally {
            this.form.reset();
            this.submitted = false;
            this.isLoading = false;
         }
      } else {
         console.log('Formulário errado:', this.form.value);
         this.form.markAllAsTouched();
      }
   }

   processarFalha(fail: any) {
      this.toastr.warning(fail.error, 'Error!');
   }

   openWhatsApp(): void {
      const msg = `Olá! Poderia me ajudar ?`;
      const baseTelefone = '55999909328';

      const whatsappUrl = buildWhatsAppUrl(baseTelefone, msg);
      window.open(whatsappUrl, '_blank');
   }

   initForm() {
      this.form = this.fb.group({
         nome: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]],
         email: ['', [Validators.required, Validators.email, Validators.minLength(4), Validators.maxLength(50)]],
         telefone: ['', [Validators.required, Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
         texto: ['', [Validators.min(1), Validators.max(500), Validators.required]]
      });
   }

   get f() {
      return this.form.controls;
   }


}
